import { useContext, useEffect, useRef, useState } from "react";
import { PreviewContext } from "../../Core/Content/Preview";
import AppService from "../../service/app.service";
// Hook to fetch footer data
export const useFooterHook = () => {
  const preview = useContext(PreviewContext);
  const [footerData, setFooterData] = useState<any>(null);
  const appService = new AppService();
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const fetchedRef = useRef(false);
  useEffect(() => {
    if (preview.preview || fetchedRef.current) return;
    fetchedRef.current = true;
    (async () => {
      try {
        const result = await appService.getPage("footer");
        setFooterData(result.data);
        setError(result.error);
        setIsLoading(result.isLoading);
      } catch (e: any) {
        setError(e);
        setIsLoading(false);
      }
    })();
  }, []);
  return {
    footerData: preview.footer || footerData,
    error,
    isLoading: preview.preview ? false : isLoading,
  };
};
